import axios from 'axios'
const integracao = {}

integracao.obterUrl = (temaId) => {
	return axios.get('/integracao/obterUrl', { params: temaId })
}

export { integracao }
